import React from 'react';
//redux import
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withLocalize } from "react-localize-redux";
//library import
import { Center } from '@mantine/core';
import { Table } from '@mantine/core';
import { Checkbox } from '@mantine/core';
import { Grid } from '@mantine/core';
import { Text, Paper, Space  } from '@mantine/core';
import { IconLayoutGrid, IconX, IconCheck } from '@tabler/icons';
import { IconTrain, IconBuildingStore, IconMap2 } from '@tabler/icons';
//component import
import Progress from '../partials/Progress';
import IconDocumentStatus from '../partials/IconDocumentStatus';
import ContainerTranslation from "../partials/ContainerTranslation";
//action import
import { fetchQuaterlyReport, uploadPicture, extractQuaterlyReport } from '../../actions/quaterlyReport';


class QuaterlyReportView extends React.Component {

    constructor(props) {
        super(props);
        const thisId = this.props.match.params.id;
        this.props.fetchQuaterlyReport(thisId);
    }

    handleExtract(){
        this.props.extractQuaterlyReport(this.props.match.params.id,this.props.languages.findIndex((l) => l.active));
    } 


    renderProjectTypeIcon(projectEnv){
        const style = { width: '8%', height: '8%' }
        if (projectEnv.length === 1 && projectEnv[0] === "Railway"){return(<><IconTrain style={style} /></>)}
        if (projectEnv.length === 1 && projectEnv[0] === "Energy"){return(<><IconTrain style={style} /></>)}
        return(<><IconLayoutGrid style={style} /></>)
    }

    uploadPicture(files) {
        if (files[0]) {
            const acceptedExtensions = [".png", ".jpg", ".jpeg"];
            const extension = files[0].name.substring(files[0].name.lastIndexOf("."));
            const isValidExtension = acceptedExtensions.find((m) => m === extension) != null;
            if(isValidExtension){
            this.setState({ popUpShowExtensionError: false });
            this.props.uploadPicture(files[0], this.props.match.params.id)
            } else {
            this.setState({ popUpShowExtensionError: true });
            }
        }
    }
    
    renderUploadPicutre(){
        return(
            <div className="input-container files" style={{ textAlign: 'center', marginTop: '10px' }}>
                <label htmlFor='picture'><ContainerTranslation  id={"Page." + ['Consultant'] + "." + ['ConsultantView'] + "." + ['Edit Profile Picture']} /></label>
                <input type="file"
                style={{ display: "none" }}
                onChange={(e) => this.uploadPicture(e.target.files)}
                id='picture' />
            </div>
        )
    }

    renderSeparator(){
        return(
            <div style={{
                width: '30px',
                height: '3px',
                background: '#eb4f1e',
                margin: '3px 0px',
            }}>
            </div>
        )
    }



    renderClientProgress(){
        let width = this.props.quaterlyReport.progress
        // this.props.quaterlyReport.validationInformation
        return(
            <div className="progress" style={{width: 'calc(100% - 30px)'}}>
                <div className="progress-header">
                    <h3>{this.props.translate("quaterlyReport.view.title")} </h3>
                    <h3>{Math.floor(width)}<ContainerTranslation id={"nav."+['completed']}/></h3>
                </div>
                <div className="progress-bar">
                    <div className="progress-line" style={{width : width+"%"}}></div>
                </div>
                <IconDocumentStatus style={{marginRight: "10px", height: "20px", width: "20px", display: "inline-block"}}
                    progression={this.clientProgress()}
                    validationInformation={{"user":"","timestamp":"","validationStatus":"document_validation_status_draft"}}
                    infovisible="true"
                    kind="project"
                    isincompleted={this.props.isincompleted}
                    translate={this.props.translate}
                /> 
            </div>
        )
    }


    renderCheckbox(target, x, y) {
        const state = this.props.quaterlyReport.content.appreciation[target][x][y]
        const CheckboxIcon = ({ indeterminate, ...others }) => {
          const opacity = state ? 1 : 0.1;
          const IconComponent = indeterminate ? IconX : IconCheck;
          return (
                <IconComponent style={{ opacity: opacity}} {...others} />
          );
        };
      
        return (
          <div>
            <Checkbox
                readOnly
                checked={state}
                color="lime.4"
                icon={CheckboxIcon}
                indeterminate={!state}
                size="md"
            />
          </div>
        );
    }

    filterDate(date){
        if(date){
            const indexOfT = date.indexOf('T');
            const resultString = indexOfT >= 0 ? date.substring(0, indexOfT) : date;
            return(resultString)
        } else {
            return(date)
        }
    }

    renderActionsPlans(actionsPlans){
        let content = []
        for(let i = 0; i<actionsPlans.length; i++){
            content.push(
                <React.Fragment key={i}>
                    <Grid.Col span={5}>
                        <Text c="dimmed" size="sm" style={{ 'word-break': 'break-all' }} >
                            {actionsPlans[i].actions}
                        </Text>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <Text c="dimmed" size="sm">
                            {this.filterDate(actionsPlans[i].deadline)}
                        </Text>
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <Text c="dimmed" size="sm" style={{ 'word-break': 'break-all' }}>
                            <Center>
                                {actionsPlans[i].pilot}
                            </Center>
                        </Text>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <Text c="dimmed" size="sm">
                            {this.filterDate(actionsPlans[i].dueDate)}
                        </Text>
                    </Grid.Col>
                </React.Fragment>
            )
        }
        return(content)
    }


    renderRows = (target) => {
        let themes = []
        if(target === "client"){
            themes = [
            <>{this.props.translate("quaterlyReport.appreciation.table1")}<Space h={42}/></>,
            <>{this.props.translate("quaterlyReport.appreciation.table2")}<Space h={21}/></>,
            <>{this.props.translate("quaterlyReport.appreciation.table3")}<Space h={42}/></>,
            <>{this.props.translate("quaterlyReport.appreciation.table4")}</>]
        } else {
            themes = [
            <>{this.props.translate("quaterlyReport.appreciation.table5")}</>,
            <>{this.props.translate("quaterlyReport.appreciation.table6")}</>,
            <>{this.props.translate("quaterlyReport.appreciation.table7")}</>,
            <>{this.props.translate("quaterlyReport.appreciation.table8")}</>]
        }
        let rows = []
        themes.map((element, rowIndex) => (
            rows.push(
                { themes: element, TS: this.renderCheckbox(target,rowIndex,0), S: this.renderCheckbox(target,rowIndex,1), MS:this.renderCheckbox(target,rowIndex,2), IS:this.renderCheckbox(target,rowIndex,3) },
            )
        ));
        return(rows)
    };



    renderAppreciationTable(){
        const elementsClient = this.renderRows("client")
        const elementsIkos = this.renderRows("ikos")
        const rowsClient = elementsClient.map((element, i) => (
            <tr key={i}>
              <td  >{element.themes}</td>
              <td  >{element.TS}</td>
              <td  >{element.S}</td>
              <td  >{element.MS}</td>
              <td  >{element.IS}</td>
            </tr>
        ));

        const rowsIkos = elementsIkos.map((element, i) => (
            <tr key={i}>
              <td>{element.themes}</td>
              <td>{element.TS}</td>
              <td>{element.S}</td>
              <td>{element.MS}</td>
              <td>{element.IS}</td>
            </tr>
        ));

        return (
            <div>
                <Grid>
                    <Grid.Col span={6}>
                        {this.props.translate("quaterlyReport.appreciation.CLIENT")}
                        <Space h="xs" />
                        <Table striped withBorder withColumnBorders >
                            <thead>
                                <tr>
                                <th>{this.props.translate("quaterlyReport.appreciation.THEMES")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.TS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.S")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.MS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.IS")}</th>
                                </tr>
                            </thead>
                            <tbody>{rowsClient}</tbody>
                        </Table>
                    </Grid.Col>
                    <Grid.Col span={6}>
                        IKOS
                        <Space h="xs" />
                        <Table style={{ whiteSpace: 'pre-line' }} striped withBorder withColumnBorders >
                            <thead>
                                <tr>
                                <th>{this.props.translate("quaterlyReport.appreciation.THEMES")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.TS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.S")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.MS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.IS")}</th>
                                </tr>
                            </thead>
                            <tbody>{rowsIkos}</tbody>
                        </Table>
                    </Grid.Col>
                </Grid>
            </div>
        );
    }

    renderTitle(title){
        return title.substring(0, 7)
    }

    
    render() {


        if (this.props.message ==="Picture updated") { this.props.fetchQuaterlyReport(this.props.match.params.id); }
        
        if(this.props.quaterlyReport === undefined || this.props.quaterlyReport.project===undefined){
            return (
              <h3>Loading...</h3>
            )
        }


        const route = this.props.quaterlyReport.authorization.write ? "/quaterlyReport/edit/" + this.props.match.params.id : null

        const proj = this.props.quaterlyReport.project
        const presentation = this.props.quaterlyReport.content.presentation
        const style = { width: '8%', height: '8%' }

        return(
            <div className="dashboard" >

                {/*header*/}
                <Space h="xl" />
                <Grid columns={14} justify="center">
                    <Grid.Col span={10}>
                        <Progress progression={this.props.quaterlyReport.progression} 
                                    validationInformation = {this.props.quaterlyReport.validationInformation} 
                                    title = {this.props.quaterlyReport.content.title ? <>{this.renderTitle( this.props.quaterlyReport.content.title )}</>:null}
                                    kind = "QuaterlyReport"
                        />
                    </Grid.Col>
                    <Grid.Col span={1}></Grid.Col>
                    <Grid.Col span={3}>
                        {route ?
                        <Link className="primary-btn filling" style={{float:"right",width:"135px",height:"48px","textDecoration": "none"}} to={{pathname:route}}>
                            {this.props.translate("quaterlyReport.view.editButton")}
                        </Link>
                        :null
                        }


                        <button onClick={this.handleExtract.bind(this)} className="primary-btn filling" 
                            style={{
                                display: 'inline-block',
                                width: '100%',
                                height: '48px',
                                textDecoration: 'none', 
                            }}>
                            <div>{this.props.translate("quaterlyReport.view.extractButton")}</div>
                        </button>

                    </Grid.Col>
                </Grid>
                
                {/*main corps*/}
                <Space h="xl" />
                <Grid columns={13} >
                    {/**side content information */}
                    <Grid.Col span={4}>
                        {/*PICTURE*/}
                        {this.props.quaterlyReport.picture64 ?
                            <img src={this.props.quaterlyReport.picture64} width="100%" alt="consultant" />
                            :
                            null
                        }    
                        {this.renderUploadPicutre()}                    
                        <Space h="md" />
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <ContainerTranslation id={['content'] + "." + ['information'] + ".title"} tag={"span"} />
                            {this.renderSeparator()}
                            <p className="bloc-content" style={{ marginBottom: 0 }}>
                                {this.renderProjectTypeIcon(proj.content.environnement['environnement-domain'])} {this.props.translate("quaterlyReport.project.Project")}
                                <br></br><Link to={{pathname:"/project/"+proj.id}}>{proj.content.information.name.length>0?<>{proj.content.information.name}</>:<>project have no title</>}</Link>
                            </p>
                            <p className="bloc-content" style={{ marginBottom: 0 }}>
                                <IconBuildingStore style={style} /> {this.props.translate("quaterlyReport.project.Client")}
                                <br></br>{ this.props.quaterlyReport.project.content.client.level_1.value }
                            </p>
                            <p className="bloc-content" style={{ marginBottom: 0 }}>
                                <i className="fas fa-user"></i> {this.props.translate("quaterlyReport.project.Consultant")}
                                <br></br><Link to={{pathname:"/consultant/"+proj.user.consultant}}>{proj.user.profile.firstName + " " + proj.user.profile.lastName}</Link>
                            </p>
                            <p className="bloc-content" style={{ marginBottom: 0 }}>
                                <i className="fas fa-user"></i> {this.props.translate("quaterlyReport.project.ManagerConsultant")} 
                                <br></br>
                                {proj.user.sageContent.manager ? 
                                    <Link to={{ pathname: "/consultant/" + proj.user.sageContent.manager.consultant }}>
                                        {proj.user.sageContent.manager.profile.firstName + " " + proj.user.sageContent.manager.profile.lastName}
                                    </Link> : null
                                }
                            </p>
                            <p className="bloc-content" style={{ marginBottom: 0 }}>
                                <i className="fas fa-user"></i>  {this.props.translate("quaterlyReport.project.ManagerProject")}
                                <br></br>{(this.props.quaterlyReport.content.presentation.manager)}
                            </p>
                            <p className="bloc-content" style={{ marginBottom: 0 }}>
                                <i className="fas fa-user"></i> {this.props.translate("quaterlyReport.project.Interlocutor")}
                                <br></br>{presentation.clientManager}
                            </p>
                            <p className="bloc-content" style={{ marginBottom: 0 }}>
                                <IconMap2 style={style} /> {this.props.translate("quaterlyReport.project.Location")}
                                <br></br>{presentation.site}
                                <br></br>{presentation.address}
                            </p>
                            {/*this.props.consultant.user.manager*/}
                            <Space h="md" />
                        </Paper>
                    </Grid.Col>
                    <Grid.Col span={9}>

                        {/*section 1 : Présentation PROJET*/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"} >
                                <Text>
                                    {this.props.translate("quaterlyReport.view.section1")}
                                </Text>
                                {this.renderSeparator()}
                            </div>
                            <p className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    {this.props.quaterlyReport.project.content.notes.objectives}
                                </>: <> no information </>} 
                            </p>
                        </Paper>
                        <Space h="lg" />




                        {/**/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section1B")}
                                {this.renderSeparator()}
                            </div>
                            <p className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    {this.props.quaterlyReport.content.technicalMeans}
                                </>: <> no information </>}
                            </p> 
                        </Paper>
                        <Space h="lg" />

                        {/**/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section1C")}
                                {this.renderSeparator()}
                            </div>
                            <p className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    {this.props.quaterlyReport.content.presentationDeliverables}
                                </>: <> no information </>}
                            </p> 
                        </Paper>
                        <Space h="lg" />

                        {/**/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section1D")}
                                {this.renderSeparator()}
                            </div>
                            <p className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    <Grid>
                                        <Grid.Col span={6}>
                                            <div style={{ textDecoration: 'underline' }} tag={"span"}>{this.props.translate(`quaterlyReport.view.section3Ccontent.pdp`) + " :\n\n"} </div>
                                            <div style={{ 'word-break': 'break-all' }} tag={"span"}>
                                                {(this.props.quaterlyReport.content.needs.pdp)}
                                            </div>
                                        </Grid.Col>
                                        <Grid.Col span={6}>
                                            <div style={{ textDecoration: 'underline' }} tag={"span"}>{this.props.translate(`quaterlyReport.view.section3Ccontent.epi`) + " :\n\n"}</div>
                                            <div style={{ 'word-break': 'break-all' }} tag={"span"}>
                                                {(this.props.quaterlyReport.content.needs.epi)}
                                            </div>
                                        </Grid.Col>
                                        <Grid.Col span={6}>
                                            <div style={{ textDecoration: 'underline' }} tag={"span"}>{this.props.translate(`quaterlyReport.view.section3Ccontent.hse`) + " :\n\n"}</div>
                                            <div style={{ 'word-break': 'break-all' }} tag={"span"}>
                                                {(this.props.quaterlyReport.content.needs.hse)}
                                            </div>
                                        </Grid.Col>
                                        <Grid.Col span={6}>
                                            <div style={{ textDecoration: 'underline' }} tag={"span"}>{this.props.translate(`quaterlyReport.view.section3Ccontent.informations`) + " :\n\n"}</div>
                                            <div style={{ 'word-break': 'break-all' }} tag={"span"}>
                                                {(this.props.quaterlyReport.content.needs.informations)}
                                            </div>
                                        </Grid.Col>
                                    </Grid>
                                </>: <> no information </>}
                            </p> 
                        </Paper>
                        <Space h="lg" />

                        {/**/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section2")}
                                {this.renderSeparator()}
                            </div>
                            <div className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <ActivityFields
                                    activities={this.props.quaterlyReport.content.activities}
                                    translate={this.props.translate}
                                /> : <> no information </>}
                            </div> 
                        </Paper>
                        <Space h="lg" />


                        {/*section 6 : RECOMMANDATIONS ET PRECONISATIONS*/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section6")}
                                {this.renderSeparator()}
                            </div>
                            <p className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    {this.props.quaterlyReport.content.recommandations}
                                </>: <> no information </>} 
                            </p>
                        </Paper>
                        <Space h="lg" />


                        {/*section 6 : RECOMMANDATIONS ET PRECONISATIONS*/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section3B")}
                                {this.renderSeparator()}
                            </div>
                            <div className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    <Center>
                                    <Grid  columns={15}>
                                        <Grid.Col span={5} >
                                            <Text fw={500} c="dimmed" size="sm">
                                                {this.props.translate("quaterlyReport.view.actions")}
                                            </Text>
                                        </Grid.Col>
                                        <Grid.Col span={3} >
                                            <Text fw={500} c="dimmed" size="sm">
                                                {this.props.translate("quaterlyReport.view.due")}
                                            </Text>
                                        </Grid.Col>
                                        <Grid.Col span={4} >
                                            <Center>
                                            
                                            <Text fw={500} c="dimmed" size="sm">
                                                {this.props.translate("quaterlyReport.view.pilot")}
                                            </Text>
                                            </Center>
                                        </Grid.Col>
                                        <Grid.Col  span={3} >
                                            <Text fw={500} c="dimmed" size="sm">
                                                {this.props.translate("quaterlyReport.view.closure")}
                                            </Text>
                                        </Grid.Col>
                                        {/*line 2 */}
                                        {this.renderActionsPlans(this.props.quaterlyReport.content.actions)}
                                    </Grid>
                                    </Center>
                                </>: <> no information </>} 
                            </div>
                        </Paper>
                        <Space h="lg" />
                            

                        {/*section 4 : problems TECHNIQUES RENCONTRES ET SOLUTIONS APPORTEES*/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section4")}
                                {this.renderSeparator()}
                            </div>
                            <p className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    {this.props.quaterlyReport.content.problems}
                                </>: <> no information </>} 
                            </p>
                        </Paper>
                        <Space h="lg" />


                        {/*section : APPRECIATION*/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.appreciation.title")}
                                {this.renderSeparator()}
                            </div>
                            <div className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    {this.renderAppreciationTable()}
                                    <Space h="xs" />
                                    <Text fs="italic" fz="xs" c="dimmed">
                                        <>{this.props.translate("quaterlyReport.appreciation.legend")}</>
                                    </Text>
                                </>: <> no information </>} 
                            </div>
                        </Paper>
                        <Space h="lg" />


                        {/*section 7 : glossary/GLOSSAIRE*/}
                        <Paper shadow="xs" radius="xs" withBorder p="xl">
                            <div tag={"span"}>
                                {this.props.translate("quaterlyReport.view.section7")}
                                {this.renderSeparator()}
                            </div>
                            <p className="bloc-content">
                                { this.props.quaterlyReport.content ? 
                                <>
                                    {this.props.quaterlyReport.content.glossary}
                                </>: <> no information </>} 
                            </p>
                        </Paper>
                        <Space h="lg" />

                    </Grid.Col>
                </Grid>

            </div>
        )
    }
}


const mapStateToProps = state => ({
    quaterlyReport: state.quaterlyReport.quaterlyReport,
    message: state.quaterlyReport.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchQuaterlyReport,
    uploadPicture,
    extractQuaterlyReport,
}, dispatch);




export default withRouter(connect(mapStateToProps,mapDispatchToProps,null)(withLocalize(QuaterlyReportView)));




class ActivityFields extends React.Component {


    render(){
      
      // props.activities
      // props.translate
  
      return (
  
        <div className="bloc">
          {this.props.activities.map((activity, i) => {
            return (
                <ActivityField
                activity = {activity}
                index = {i}
                translate = {this.props.translate}
            />
            )
          })}
        </div>
      )
    }
  
  }


class ActivityField extends React.Component {
  
    render(){
      
      //props.activity.name
      //props.activity.tasks
      //props.index
      //props.translate

  
      return (
          <div style={{
              width: '90%',
              marginBlock: '30px',
              marginInline: 'auto',
              borderWidth: '2px',
              borderStyle: 'solid',
              borderColor: 'black'
          }}>
              <p>{this.props.activity.name}</p>
              <TaskFields
                  tasks={this.props.activity.tasks}
                  index={this.props.index}
                  translate={this.props.translate}
              />
          </div>
      )
    }
  
  }



class TaskFields extends React.Component {


    render(){
      
  
      // props.tasks
      // props.translate
      // props.index

  
      return (
  
        <div className="bloc">
          {this.props.tasks.map((task, i) => {
            return (
              <TaskField
                key={`task-${this.props.index}-${i}`} 
                task = {task}
                translate = {this.props.translate}
              />
            )
          })}
        </div>
      )
    }
  
  }
  
  
  
  
  
  
  
  
  
  
  
  
  class TaskField extends React.Component {
  
    getProgressionBarColor(progression){
        let color = '#989DA3'
        if (progression > 0) {
          color = '#CF3440'
        }
        if (progression > 25) {
          color = '#CF8B44'
        }
        if (progression > 50) {
          color = '#CFC544'
        }
        if (progression > 75) {
          color = '#99CC66'
        }
        color = '' + color + '';
        return(color);
      }

      getProgressionTextColor(progression){
        return progression > 50 ? "#fff" : "black";
      }


      formatDate(date){
        if (date === null){
            return ""
        }
        return date.split('T')[0]
      }

    render(){
      
  
  
      //props.task.name
      //props.task.description
      //props.task.deliveryDateExpected
      //props.task.deliveryDateActual
      //props.task.progression
      //props.task.result
      //props.translate

  
        const barColor = this.getProgressionBarColor(this.props.task.progression)
        const textColor = this.getProgressionTextColor(this.props.task.progression)
        
      return (
          <div style={{ width: '90%', marginBlock: '30px', marginInline: 'auto' }}>
              <div className="field-separator"/>
              <div className="button-bar" style={{ height: '20px' }}>
                  <p title={this.props.task.name} style={{ display: 'inline-block', width: '70%', marginBlockStart: '0px', marginBlockEnd: '0px', overflowX: 'auto' }}>
                      {this.props.task.name}
                  </p>
                  <div className="progress-bar" style={{ width: "30%", height: "100%", position: "relative" }}>
                      <div className="progress-line" style={{ width: this.props.task.progression + "%", backgroundColor: barColor, height: "100%" }} />
                      <span
                          className="progress-text"
                          style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              color: textColor, // or another color that contrasts with your background
                              fontWeight: "bold",
                              zIndex: 1,
                              pointerEvents: "none", // ensures it doesn’t interfere with mouse events
                          }}
                      >
                          {this.props.task.progression}%
                      </span>
                  </div>
              </div>
              <div style={{ marginBlock: 'auto' }}>
                  <p style={{ fontSize: "12px", width: '30%', display: 'inline-block', textDecoration: 'underline' }}>Expected delivery date</p>
                  <p style={{ fontSize: "12px", width: '20%', display: 'inline-block' }}>{this.formatDate(this.props.task.deliveryDateExpected)}</p>
                  <p style={{ fontSize: "12px", width: '30%', display: 'inline-block', textDecoration: 'underline' }}>Actual delivery date :</p>
                  <p style={{ fontSize: "12px", width: '20%', display: 'inline-block' }}>{this.formatDate(this.props.task.deliveryDateActual)}</p>
              </div>
              <p style={{ fontSize: "12px", display: "block", marginBlock: 'auto', textDecoration: 'underline' }}>Description</p>
              <p style={{
                  display: "block",
                  color: "#989DA3",
                  fontSize: "12px",
                  lineHeight: "calc(16px + 8px)",
                  marginLeft: "0px",
                  paddingLeft: "0px",
                  marginBlock: 'auto'
              }}
              >
                  {this.props.task.description}
              </p>
              <p style={{ fontSize: "12px", display: "block", marginBlock: 'auto', textDecoration: 'underline' }}>Result</p>
              <p style={{
                  display: "block",
                  color: "#989DA3",
                  fontSize: "12px",
                  lineHeight: "calc(16px + 8px)",
                  marginLeft: "0px",
                  paddingLeft: "0px",
                  marginBlock: 'auto'
              }}
              >
                  {this.props.task.result}
              </p>
          </div>
      )
    }
  
  }
  